import React, { useState, useEffect } from 'react';
// YENİ EKLENDİ: React Router'dan gerekli araçları import ediyoruz
import { Routes, Route, useNavigate, Link, Navigate, NavLink } from 'react-router-dom';
import Login from './Login';
import DiyetisyenRoutes from './DiyetisyenRoutes';
import AdminRoutes from './AdminRoutes';
import KlinikRoutes from './KlinikRoutes';     // KlinikRoutes'u import edelim
import KarsilamaSayfasi from './KarsilamaSayfasi';
import DemoTalepFormu from './DemoTalepFormu';
import SifreDegistirModal from './SifreDegistirModal';
import api from './api';
import SifremiUnuttum from './SifremiUnuttum';
import YuklemeGostergesi from './YuklemeGostergesi';
import SifreSifirla from './SifreSifirla';
import KvkkSayfasi from './KvkkSayfasi';
import './App.css';
import './themes.css';
import './modern.css';
import './bento.css';

// Bento üst menü / mobil alt menü bağlantıları (eski yan menüyle birebir aynı sayfalar)
const NAV_ITEMS = {
  diyetisyen: [
    { to: '/', label: 'Bugün', icon: 'space_dashboard', end: true },
    { to: '/danisanlar', label: 'Danışanlar', icon: 'group' },
    { to: '/randevular', label: 'Randevularım', icon: 'calendar_month' },
    { to: '/kutuphane/besinler', label: 'Kütüphanem', icon: 'restaurant_menu' },
    { to: '/sablonlar', label: 'Şablonlarım', icon: 'note_stack' },
    { to: '/destek', label: 'Destek', icon: 'headset_mic' },
  ],
  klinik: [
    { to: '/', label: 'Ana Sayfa', icon: 'space_dashboard', end: true },
    { to: '/takvim', label: 'Takvim', icon: 'calendar_month' },
    { to: '/randevu-ata', label: 'Randevu Ata', icon: 'edit_calendar' },
    { to: '/diyetisyenler', label: 'Diyetisyenler', icon: 'clinical_notes' },
    { to: '/danisanlar', label: 'Danışanlar', icon: 'group' },
  ],
  admin: [
    { to: '/', label: 'Ana Sayfa', icon: 'space_dashboard', end: true },
    { to: '/admin/diyetisyenler', label: 'Diyetisyenler', icon: 'badge' },
    { to: '/admin/paketler', label: 'Paketler', icon: 'inventory_2' },
    { to: '/admin/klinikler', label: 'Klinikler', icon: 'domain' },
    { to: '/admin/abonelikler', label: 'Abonelikler', icon: 'credit_card' },
    { to: '/admin/karsilama', label: 'Karşılama', icon: 'web' },
    { to: '/admin/destek', label: 'Destek', icon: 'support_agent', badge: true },
  ],
};

function App() {
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'light');
  // Bento arayüzüne geçişte herkes bir kez Bento temasına alınır; sonrasında Profil'den değiştirebilir.
  const [themePreset, setThemePreset] = useState(() => {
    if (localStorage.getItem('arayuzSurumu') !== 'bento') {
      localStorage.setItem('arayuzSurumu', 'bento');
      return localStorage.getItem('theme') === 'dark' ? 'bento-dark' : 'bento-light';
    }
    return localStorage.getItem('themePreset') || 'bento-light';
  });
  const [token, setToken] = useState(localStorage.getItem('accessToken'));
  const [userRole, setUserRole] = useState(localStorage.getItem('userRole'));
  const [profilMenuAcik, setProfilMenuAcik] = useState(false);
  const [sifreDegistirildi, setSifreDegistirildi] = useState(localStorage.getItem('sifreDegistirildi') !== 'false');
  const [acikTicketSayisi, setAcikTicketSayisi] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.setAttribute('data-bs-theme', theme);
    document.documentElement.setAttribute('data-theme-preset', themePreset);
    localStorage.setItem('theme', theme);
    localStorage.setItem('themePreset', themePreset);
  }, [theme, themePreset]);

  // Zorunlu şifre değişikliği durumunu sunucudan doğrula.
  // Token değiştiğinde (giriş dahil) çalışır; böylece modal giriş anında
  // görünür ve localStorage'daki bayrak sunucudan farklıysa düzeltilir.
  useEffect(() => {
    if (!token) return undefined;
    let iptalEdildi = false;
    api.get('/sifre-durumu')
      .then((res) => {
        if (iptalEdildi) return;
        const degistirildi = res.data?.sifre_degistirildi !== false;
        localStorage.setItem('sifreDegistirildi', degistirildi ? 'true' : 'false');
        setSifreDegistirildi(degistirildi);
      })
      .catch(() => { /* sunucuya ulaşılamadıysa mevcut duruma dokunma */ });
    return () => { iptalEdildi = true; };
  }, [token]);

  // Admin için açık ticket sayısını periyodik olarak çek (badge için)
  useEffect(() => {
    if (userRole !== 'admin' || !token) return;
    const fetchAcikTicket = async () => {
      try {
        const res = await import('./api').then(m => m.default.get('/admin/analitik?periyot=7'));
        setAcikTicketSayisi(res.data?.ozet?.acik_ticket_sayisi || 0);
      } catch { /* sessizce geç */ }
    };
    fetchAcikTicket();
    const interval = setInterval(fetchAcikTicket, 60000); // Her dakika güncelle
    return () => clearInterval(interval);
  }, [userRole, token]);

  const handleLogout = () => {
    localStorage.clear();
    setToken(null);
    setUserRole(null);
    navigate('/');
  };

  const handleThemeChange = (preset) => {
    const mode = preset.startsWith('dark') ? 'dark' : 'light';
    setTheme(mode);
    setThemePreset(preset);
  };

  // Eğer token VARSA, yani kullanıcı giriş yapmışsa, paneli göster.
  if (token) {
    const navItems = NAV_ITEMS[userRole === 'admin' ? 'admin' : (userRole === 'klinik_yoneticisi' ? 'klinik' : 'diyetisyen')];
    const panelAdi = userRole === 'admin' ? 'Admin Paneli' : (userRole === 'klinik_yoneticisi' ? 'Klinik Paneli' : 'Diyetisyen');
    const kullaniciAdi = localStorage.getItem('kullaniciAdi') || '';
    const basHarfler = (kullaniciAdi || panelAdi).slice(0, 2).toUpperCase();
    const isDark = theme === 'dark';
    const toggleTheme = () => {
      if (themePreset.startsWith('bento')) handleThemeChange(isDark ? 'bento-light' : 'bento-dark');
      else handleThemeChange(isDark ? themePreset.replace('dark', 'light') : themePreset.replace('light', 'dark'));
    };
    const navLink = (item, cls) => (
      <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => (isActive ? `active ${cls || ''}` : cls || '')}>
        <span className="material-symbols-outlined">{item.icon}</span>
        <span>{item.label}</span>
        {item.badge && acikTicketSayisi > 0 && <span className="nav-badge">{acikTicketSayisi}</span>}
      </NavLink>
    );

    return (
      <>
        <YuklemeGostergesi />
        {/* Şifre değiştirme zorunlu modal */}
        {!sifreDegistirildi && <SifreDegistirModal onComplete={() => setSifreDegistirildi(true)} onLogout={handleLogout} />}

        <div className="bento-app">
          {/* ÜST BAR */}
          <header className="bento-topbar">
            <Link to="/" className="bento-logo">
              <span className="bento-logo-mark"><span className="material-symbols-outlined">nutrition</span></span>
              <span>Diyet-Takip<small>{panelAdi}</small></span>
            </Link>
            <nav className="bento-nav">{navItems.map(item => navLink(item))}</nav>
            <div className="bento-topbar-spacer" />
            <button type="button" className="bento-icon-btn" onClick={toggleTheme} title={isDark ? 'Aydınlık temaya geç' : 'Karanlık temaya geç'}>
              <span className="material-symbols-outlined">{isDark ? 'light_mode' : 'dark_mode'}</span>
            </button>
            <div className="position-relative">
              <button type="button" className="bento-avatar" onClick={() => setProfilMenuAcik(v => !v)} title="Hesabım">{basHarfler}</button>
              {profilMenuAcik && (
                <>
                  <div style={{ position: 'fixed', inset: 0, zIndex: 1050 }} onClick={() => setProfilMenuAcik(false)} />
                  <div className="bento-menu">
                    <div className="bento-menu-head"><b>{kullaniciAdi || 'Hesabım'}</b><small>{panelAdi}</small></div>
                    <Link to="/profil" onClick={() => setProfilMenuAcik(false)}><span className="material-symbols-outlined">person</span>Profilim</Link>
                    <button type="button" onClick={() => { toggleTheme(); setProfilMenuAcik(false); }}>
                      <span className="material-symbols-outlined">{isDark ? 'light_mode' : 'dark_mode'}</span>{isDark ? 'Aydınlık tema' : 'Karanlık tema'}
                    </button>
                    <button type="button" className="danger" onClick={handleLogout}><span className="material-symbols-outlined">logout</span>Çıkış Yap</button>
                  </div>
                </>
              )}
            </div>
          </header>

          {/* ANA İÇERİK ALANI */}
          <main className="bento-main">
            {userRole === 'admin' ? <AdminRoutes theme={theme} themePreset={themePreset} onThemeChange={handleThemeChange} /> : (userRole === 'klinik_yoneticisi' ? <KlinikRoutes theme={theme} themePreset={themePreset} onThemeChange={handleThemeChange} /> : <DiyetisyenRoutes theme={theme} themePreset={themePreset} onThemeChange={handleThemeChange} />)}
          </main>

          {/* MOBİL ALT MENÜ */}
          <nav className="bento-bottomnav">{navItems.map(item => navLink(item))}</nav>
        </div>
      </>
    );
  }

  // Eğer token YOKSA, yani kullanıcı giriş yapmamışsa, Karşılama veya Giriş sayfasını göster.
  return (
    <>
    <YuklemeGostergesi />
    <Routes>
      <Route path="/" element={<KarsilamaSayfasi />} />
      <Route path="/giris" element={<Login setToken={setToken} setUserRole={setUserRole} />} />
      <Route path="/demo-talep" element={<DemoTalepFormu />} />
      <Route path="/sifremi-unuttum" element={<SifremiUnuttum />} />
      <Route path="/sifre-sifirla" element={<SifreSifirla />} />
      <Route path="/kvkk" element={<KvkkSayfasi sayfa="aydinlatma" />} />
      <Route path="/gizlilik-politikasi" element={<KvkkSayfasi sayfa="gizlilik" />} />
      {/* Giriş yapmamış kullanıcılar diğer tüm URL'lere giderse giriş sayfasına yönlendir */}
      <Route path="*" element={<Navigate to="/giris" replace />} />
    </Routes>
    </>
  );
}

export default App;